import {
  Dialog,
  DialogContentText,
  Grid,
  makeStyles,
} from "@material-ui/core";
import React from "react";
import StepWizard from "react-step-wizard";
import CloseIcon from "@material-ui/icons/Close";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import styles from "../../meter/components/2Factor/informationModal.module.scss";
import { EnterEmail } from "./EnterEmail";
import { EmailVerificationCode } from "./EmailVerificationCode";
import { useTranslation } from "react-i18next";

interface IEmailVerificationStepper {
  onClose(): any;
  open: boolean;
  currentEmail: string | null;
}

const useStyles = makeStyles({
  paper: {
    minWidth: "100%",
    position: "absolute",
    bottom: 0,
    margin: 0,
    borderRadius: 0,
  },
});

export const EmailVerificationStepper: React.FC<IEmailVerificationStepper> = (
  props
) => {
  const classes = useStyles();
  const { open, onClose, currentEmail } = props;
  const [activeStepOutter, setActiveStepOutter] = React.useState<number>(1);
  const [proposedEmail, setProposedEmail] = React.useState<string>(currentEmail || "");
  const [instance, setInstance] = React.useState<any>();

  const handleFinalOnClose = () => {
    setActiveStepOutter(1);
    setProposedEmail("");
    //@ts-ignore
    onClose(true);
  };

  const handleClose = () => {
    onClose();
  };

  const { t } = useTranslation();
  return (
    <Dialog
      onClose={() => handleClose()}
      open={open}
      classes={{ paper: classes.paper }}
    >
      <Grid container direction="column" wrap="nowrap">
        <Grid
          container
          direction="row"
          justifyContent={activeStepOutter > 1 ? "space-between" : "flex-end"}
        >
          {activeStepOutter > 1 && (
            <Grid item onClick={() => instance.goToStep(activeStepOutter - 1)}>
              <div className={styles.cross}>
                <ArrowBackIcon fontSize="medium" color="primary" />
                <DialogContentText color="primary">
                  {t("Back")}
                </DialogContentText>
              </div>
            </Grid>
          )}
          <Grid item onClick={() => handleClose()}>
            <div className={styles.cross}>
              <CloseIcon fontSize="medium" color="primary" />
              <DialogContentText color="primary">
                {t("Close")}
              </DialogContentText>
            </div>
          </Grid>
        </Grid>
        <StepWizard
          onStepChange={(stepChange) =>
            setActiveStepOutter(stepChange.activeStep)
          }
          instance={(instance) => setInstance(instance)}
          initialStep={activeStepOutter}
        >
          <EnterEmail
            setProposedEmail={setProposedEmail}
            email={proposedEmail}
            currentEmail={currentEmail}
          />
          <EmailVerificationCode
            onClose={handleFinalOnClose}
            email={proposedEmail}
          />
        </StepWizard>
      </Grid>
    </Dialog>
  );
};
